<template>
  <div class="flip-card col-xl-3 col-lg-4 col-md-6 mt-4">
    <div class="flip-card-inner">
      <router-link
        class="text-decorator"
        :to="option.route"
        :event="option.needSelectedStudent && !hasSelectedStudent ? '' : 'click'"
        @click.native.prevent="goToRoute(option.route)"
      >
        <div class="flip-card-front">
          <div class="col-xs-7 py-2">
            <img :src="showImage(option.mainImage)" class="rounded-circle" />
            <h3 class="card-front-title">{{ option.title }}</h3>
            <p class="px-4 card-front-p">{{ option.description }}</p>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SquareOption',
  meta: {
    description: 'Componente común de opciones en tarjeta ',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    option: {
      type: Object,
      default: () => ({}),
      meta: {
        description: 'Establece las opciones del SquareOption',
        example: 'this.SquareData',
      },
    },
  },
  data() {
    return {
      hasSelectedStudent: false,
    }
  },
  computed: {
    rotateCard() {
      return this.option.rotate == undefined ? true : this.option.rotate
    },
  },
  methods: {
    goToRoute(route) {
      if (!this.hasSelectedStudent && this.option.needSelectedStudent) {
        //Esto esta MAL (Deberia ser emmit)
        // store.commit("toggleSearchMenu");
        // store.commit("setNavigationToViewRoute",route);
        event.stopImmediatePropagation()
        return
      }
      // this.$store.commit("showStudentBox", this.option.needSelectedStudent);
      this.$router.push(route).catch(() => {})
    },
    showImage(imgName) {
      try {
        return require(`@/assets/img/${imgName}`)
      } catch {
        //ECG:Nah
        //return require("@/assets/logo.svg"); //Imagen por default
      }
    },
  },
}
</script>

<style scoped>
.text-decorator {
  text-decoration: none;
}
.option-title {
  font-size: 12.5px;
}
.menu-item {
  height: 115px;
  width: 225px;
}

.flip-card {
  padding: 20px 0px;
  background-color: transparent;
  height: auto;
  perspective: 1000px; /* Remove this if you don't want the 3D effect */
}

/* This container is needed to position the front and back side */
.flip-card-inner {
  position: relative;
  width: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

/* Style the front side (fallback if image is missing) */
.flip-card-front {
  background: transparent linear-gradient(180deg, #ffffff 0%, #f2f2f2 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  color: black;

  position: absolute;
  width: 100%;

  backface-visibility: hidden;
}

.card-front-title {
  color: #2db782;
  margin-top: -20px;
  font: Bold 14px/17px Lato;
}

.card-front-p {
  font: 12px/16px Lato;
  letter-spacing: 0;
  color: black;
}

.cursor-pointer {
  cursor: pointer;
}

/*Card breakpoints */

/*(XS default)*/
.flip-card-inner {
  height: 190px;
  width: 300px;
  margin: 0 auto;
}

.flip-card-front {
  height: 190px;
}

</style>
